import styled from 'styled-components';

export const DropdownStyled = styled.div<{ $isOpen: boolean }>`
  box-sizing: border-box;
  padding-bottom: 1em;

  border-bottom: 1px solid var(--color-border-low-contrast, #f0f0f0);
  background: var(--color-background-surface, #fff);

  svg {
    transition-duration: 200ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    ${props => (props.$isOpen ? 'transform: rotate(180deg);' : '')}
  }
`;

export const DropdownSelectStyled = styled.button`
  position: relative;
  display: flex;
  gap: 0.875em;
  justify-content: space-between;
  align-items: center;
  padding: 0.5em;
  width: 100%;

  background: var(--color-background-surface, #fff);
  border-radius: 0.1875em;
  border: 2px solid var(--input-color-border-base, #949494);
  color: var(--color-text-high-contrast, #444);

  /* Normal/text-preset-6 */
  font-size: 0.875em;
  font-style: normal;
  font-weight: 400;
  line-height: 1.72em; /* 171.429% */

  &.disabled {
    background: var(--color-border-low-contrast, #f0f0f0);
    filter: opacity(0.7);
  }

  &:active {
    border: 2px solid var(--brand-darker, #00857e);
  }
  &:focus {
    border: 2px solid var(--brand-darker, #00857e);
    outline: 2px solid transparent;
    box-shadow: outset 0 0 0 2px var(--a11y);

    .focus-ring {
      border-radius: 0.1875em;
      box-shadow:
        0px 0px 0px 2px #fff,
        0px 0px 0px 4px var(--a11y);
    }
  }

  &.expanded {
    border-color: var(--brand-darker, #00857e);
  }

  .focus-ring {
    position: absolute;
    width: calc(100% + 0.5em);
    height: 3em;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

export const DropdownMenuStyled = styled.div`
  position: absolute;
  left: 0;
  z-index: 10;
  padding: 0em 1em;
  border-radius: 0.1875em;
  box-sizing: border-box;
  width: 100%;

  .dropdown-menu {
    overflow-y: auto;
    max-height: 50vh;

    display: flex;
    padding: 0.5em 0em;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;

    border-radius: 0em 0em 0.1875em 0.1875em;
    border: 1px solid var(--color-border-high-contrast, #949494);
    border-top: none;
    background: var(--color-background-surface, #fff);

    /* Shadow/Depth 2 */
    box-shadow:
      0px 0.3px 1.3px 0px rgba(0, 0, 0, 0.04),
      0px 0.9px 4.5px 0px rgba(0, 0, 0, 0.08),
      0px 4px 20px 0px rgba(0, 0, 0, 0.1);

    ul {
      list-style: none;
      padding-inline: 0;
      margin: 0;
      /* width: fit-content; */
      width: 100%;
      box-sizing: border-box;
      line-height: 1.72em;
    }
  }
`;

export const DropdownMenuItemStyled = styled.li`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  cursor: pointer;

  &:hover {
    background: var(--color-extended-subtle-blue, #eaf3fb);
  }
  &:active {
    border: 0.125em solid var(--color-midnight-lightest);
  }
  &:focus {
    border: 0.125em solid var(--color-midnight-lighter);
  }

  padding: 0.5em 0em;
  border-bottom: 1px solid var(--color-border-low-contrast, #f0f0f0);
  background: var(--color-background-surface, #fff);

  div {
    padding: 0em 1em;
    /* text-wrap: nowrap; */
    font-size: 0.875em;
    line-height: 1.72em; /* 171.429% */

    &.audience-name {
      color: var(--color-text-high-contrast, #444);
      font-weight: 700;
    }
    &.audience-description {
      color: var(--color-text-low-contrast, #595959);
      font-weight: 400;
    }
  }
`;
